import React from "react";
 

import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Label, Input, Button, Badge } from "reactstrap";
import { useState, useEffect, useRef, useMemo, useCallback, useContext } from "react";
import { genericGet, genericPost } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS ,LOCAL_PATHS} from "../../../Constants";
import ability from '../../config/defineAbility';
import { PERMS } from '../../config/perms'
import { Fab, Action } from 'react-tiny-fab';
import 'react-tiny-fab/dist/styles.css';
import AppContext from "../../../AppContext";
import {
  
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
 
} from 'reactstrap';
import { Spinner } from "reactstrap";
import { FaTimes, FaEdit, FaFileExport, FaArrowRight } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { Component } from "ag-grid-community";
import CardBox from "../../../components/CardBox";
import { ListEmployeeApi } from "../../../services/Api";

const ExceptionalInAttendance = (props) => {
  const global = useContext(AppContext);
 
  const history = useHistory();
  const [is_loading, setIsLoading] = useState(false);
  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const gridRef2 = useRef();

  const [gridApi, setGridApi] = useState(null);
 const [Processing, setProcessing] = useState(false)
  const [status, setstatus] = useState('')

const [selected_taxes, setSelected_taxes] = useState([])
const [selected_staff, setSelected_staff] = useState([])


 const [taxes, setTaxes] = useState([])
const [showModal, setshowModal] = useState(false)
const [selected_payroll, setselected_payroll] = useState(null)
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);
  const toggle = () => setshowModal(!showModal);
 
  useEffect(() => {
 
    fetch_employee_data();
    get_taxes();
    return () => {};
  }, []);

  const fetch_employee_data = () => {
    setProcessing(true);

    ListEmployeeApi()
      .then((res) => {
        setProcessing(false);
        //gridRef.current.api.showLoadingOverlay();
        if (res.status == 200) {
          var response = res.data;
          console.log(JSON.stringify(res.data));
          if (response.status == SUCCESS_RESULT) {
            let _data = [];
            if (response.data?.length < 1) {
              alert("No Record ");
              return;
            }

            setRowData(response.data);
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        } else {
          {
            cogoToast.error(res.message, {
              hideAfter: 5,
            });
          }
          cogoToast.error(res.message, {
            hideAfter: 5,
          });
        }
      })
      .catch((err) => {
        setProcessing(false);
        console.log(err);
        cogoToast.error(err, {
          hideAfter: 5,
        });

        cogoToast.error("Something went wrong, please Try again.", {
          hideAfter: 5,
        });
      });
  };
  const get_taxes = (_status) => {
    setIsLoading(true);
 
    genericGet(ENDPOINTS.LIST_INATTENDANCE_TYPES)
    .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
            if (res.data.status !== SUCCESS_RESULT) {
                let responseData = res.data.data;
             
                setTaxes(responseData);
            } else {
                cogoToast.error(res.data.message, {});
            }
        }
    })
    .catch((err) => {
        setIsLoading(false);
        console.log(err);
    });
   
  };

  const saveTaxes =  (e) => {
    setIsLoading(true)
    e?.preventDefault();

let _data=[];
let _taxes=[];
let _staff_arry=[];
taxes:gridRef2?.current?.api?.getSelectedRows().forEach((a)=>{
  _taxes.push(a.id);
})
gridRef?.current?.api?.getSelectedRows().forEach(element => {
  
  _staff_arry.push(element.id)

});
 




_data={
  "staff":_staff_arry,
  "date":"2025-01-06",
  "hours":"7.5",
  "inattendance_type_id":_taxes[0],
  "remakrs":"Mawlid al-Nabi (مولد النبي)"
};


  console.clear();
  console.log(_data);
  return;
  genericPost(ENDPOINTS.CREATE_INATTENDANCE_TYPES, _data)
  .then((response) => {
      setIsLoading(false);
      setshowModal(false)
      if (response.status == 200) {
          if (response.data.status == SUCCESS_RESULT) {
           
              cogoToast.success(response.data.message, {
                  hideAfter: 5,
              });
              global.show_operation_result({success:true,message:response.data.message})
             
          } else {
              cogoToast.error(response.data.message, {
                  hideAfter: 5,
              });
          }
      }
  })
  .catch((err) => {
      setIsLoading(false);
      console.log(err);
      cogoToast.error("Something went wrong, please Try again. " + err, {
          hideAfter: 5,
      });
  });
   
   
  }
  return (
    <div>
  
      <div className="row">
        <div className="col-md-4">
        <h1> ➊ Select InAttendance Type </h1>
        <div className="ag-theme-alpine">
        <AgGridReact
          suppressMenuHide={true}
          ref={gridRef2}
          rowSelection={"multiple"}
          groupSelectsChildren={true}
          suppressRowClickSelection={true}
          onRowSelected={(e) => {
            if (e.data?.id != null) {
              setSelected_taxes(gridRef2?.current?.api?.getSelectedRows())
            } else {
            
              return;
            }
          }}
          onSelectionChanged={(e) => {
            if ( e.data?.staff != null) {
              //calculate_tests();
            }
          }}

          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center"> loading data...</span>'
          }
          onGridReady={(params) => {
            setGridApi(params.api);
          //  params.api.showLoadingOverlay();
          }}
          rowData={taxes}
          domLayout={"autoHeight"}
          animateRows={true}
          onRowDoubleClicked={(e) => console.log(e.data)}
          pagination={true}
          paginationPageSize={100}
          defaultColDef={defaultColDef}
          resizable={true}
          enableCellTextSelection={true}
          suppressCellSelection={true}
          columnDefs={[
            {
              headerName: "#",
              filter: false,
              maxWidth: 70,
              sortable: true,
              valueFormatter: function (params) {
                return `${parseInt(params.node.id) + 1}`;
              },
            },

            {
              headerCheckboxSelection: true,
              checkboxSelection: true,
              headerName: "Type ",
              field: "name",
              sortable: true,
              filter: true,
            },
            {
             
              headerName: "Desc ",
              field: "description",
              sortable: true,
              filter: true,
            },
          
          ]}
        ></AgGridReact>
        
    
      </div> 

      <br/>
 <h1> 
Selected taxes : <b> {selected_taxes?.length} </b>    &nbsp; &nbsp; &nbsp;   

</h1>
<button className="btn btn-primary" 
 
onClick={(e)=>{
    setshowModal(true);
 
  }}>➌ Assign InAttendance Type </button>
        </div>
        <div className="col-md-8">
        <h1> ➋ Select Staff </h1>

        <div className="ag-theme-alpine">
        <AgGridReact
          suppressMenuHide={true}
          
          ref={gridRef}
          rowSelection={"multiple"}
          groupSelectsChildren={true}
          suppressRowClickSelection={true}
          
          onRowSelected={(e) => {
            if (e.data?.staff_id != null) {
              
            } else {
            
              return;
            }
          }}
          

          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center"> loading data...</span>'
          }
          onGridReady={(params) => {
            setGridApi(params.api);
           params.api.showLoadingOverlay();
          }}
          rowData={rowData}
          domLayout={"autoHeight"}
          animateRows={true}
          onRowDoubleClicked={(e) => console.log(e.data)}
          pagination={true}
          paginationPageSize={100}
          defaultColDef={defaultColDef}
          resizable={true}
          enableCellTextSelection={true}
          suppressCellSelection={true}
          columnDefs={[
            {
              headerName: "#",
              filter: false,
              maxWidth: 70,
              sortable: true,
              valueFormatter: function (params) {
                return `${parseInt(params.node.id) + 1}`;
              },
            },
            {
              headerCheckboxSelection: true,
              headerCheckboxSelectionFilteredOnly:true,
              checkboxSelection: true,
              headerName: "Staff ID",
              field: "staff_id",
              sortable: true,
              filter: true,
            },
            {
         
              headerName: "Staff Name",
              field: "staff_name",
              sortable: true,
              filter: true,
            },
            
            {
              headerName: "Email ",
              field: "email",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Role  ",
              field: "role_name",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Office  ",
              field: "office_name",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Staff Taxes  ",
              field: "staff_taxes",
              sortable: true,
              filter: true,
              cellRendererFramework: (e) => {
                // return JSON.stringify(e.data?.staff_taxes);
return <b>{e.data?.staff_taxes?.length}</b>

return JSON.stringify(e.data?.staff_taxes)
 
                return (
                  <span>
                  {e.data?.staff_taxes.map((a)=>{
                    return <><Badge>{a.tax_name}</Badge>&nbsp; </>
                  })}
                  </span>
                )}

            },
            // {
            //   headerName: "staff_allowances  ",
            //   field: "staff_allowances",
            //   sortable: true,
            //   filter: true,
            //   cellRendererFramework: (e) => {

 
            //     return (
            //       <span>
            //       {e.data?.staff_allowances.map((a)=>{
            //         return <><Badge>{a.name}</Badge>&nbsp; </>
            //       })}
            //   </span>
            //     )}

            // },
           

          ]}
        ></AgGridReact>
      </div> 
          </div>
      </div>
    

<hr/>



 

      <Modal
        isOpen={showModal}
        onHide={() => setshowModal(false)}
        
        backdrop={true}
      
      >
        <ModalHeader  toggle={toggle}>
          <div className="row">
             Confirm inattendance Type to assign 
               
               
          </div>
           
          
         </ModalHeader>
        <ModalBody>
      

        <form onSubmit={saveTaxes}>
          <h1> SELECTED STAFF  : {gridRef?.current?.api?.getSelectedRows().length} out of {rowData.length}</h1> <hr/>
          <h1>
         
            <ul>
            
            Selected InAttendance Type : {selected_taxes.map((a)=>{
           return  <b>   <br/> ► { a.name}  </b>
          }) }
          </ul>
          </h1>

Date
          <input type="date" name="date" className="form-control"></input>
          Hours 
          <input type="text" name="hours" className="form-control"></input>
          Remarks
          <input type="text" name="remarks" className="form-control"></input>
          <br/>
          <br/>

          {!is_loading?
    <input  type="submit" disabled={gridRef?.current?.api?.getSelectedRows().length==0 || gridRef2?.current?.api?.getSelectedRows().length==0} className="btn btn-primary" value="Assign InAttendance" ></input> : <button className="btn btn-primary" disabled={true}><Spinner /> &nbsp; Processing..</button>  }

     
    </form>
        </ModalBody>
      
      </Modal>

     
      
    </div>



  );
};

export default ExceptionalInAttendance;
